import { AppBar } from "@/layout";
import React from "react";
import auttomlogo from "../../assets/images/icon-auttom.png";

const Support: React.FC = () => {
  return (
    <div>
      <div className="max-w-5xl mx-auto px-4 py-12 text-center">
        <img
          src={auttomlogo}
          width={40}
          height={40}
          alt="auttom logo"
          className="mx-auto mb-2"
        />
        <h1 className="text-4xl font-bold mb-6">Support</h1>

        <p className="text-lg mb-10 max-w-2xl mx-auto">
          For any information or assistance, please contact us at the email
          address below. We are here to help and will respond as soon as
          possible.
        </p>

        <a
          href="https://auttom.io/help-and-support/report-issue"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center bg-gray-600 hover:bg-gray-700 text-white font-semibold px-6 py-3 rounded-md transition"
        >
          <svg
            className="w-5 h-5 mr-2"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16 12l-4-4m0 0l-4 4m4-4v8"
            />
          </svg>
          i@auttom.io
        </a>
      </div>
    </div>
  );
};

export default Support;
